import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { CONFIG } from 'app/config/config';
import { Session } from 'app/shared/services/session/session.service';
import { Lesson } from '../models';

@Injectable()
export class LessonsService {
  lessons: Lesson[];
  selectedIndexTab: string = '';

  constructor(private _http: Http, private _session: Session) { }

  getAllLessons() : Promise<Lesson[]> {
    let self = this;
    if (this.lessons) return Promise.resolve(this.lessons);
    else return this._http.get(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/lessons', { headers: this._session.headers() })
      .toPromise()
      .then(data => {
        let lessonJson: any[] = data.json();
        self.lessons = lessonJson.map(lesson => new Lesson(lesson));
        self.sortLessons();
        return self.lessons;
      });
  }

  deleteLesson(lessonID: string | number) {
    return this._http.delete(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/lessons/' + lessonID,
      { headers: this._session.headers() })
      .toPromise()
      .then(() => {
        this.lessons = null;
        return this.getAllLessons();
      });
  }

  createLesson(lesson: Lesson) : Promise<any> {
    return this._http.post(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/lessons',
      lesson.toJson(), { headers: this._session.headers() })
      .toPromise()
      .then(() => {
        this.lessons = null;
        return this.getAllLessons();
      });
  }

  saveEditedLesson(updatedLesson: Lesson) : Promise<any> {
    if (updatedLesson.id) {
      return this._http.put(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/lessons/' + updatedLesson.id,
      updatedLesson.toJson(), { headers: this._session.headers() })
      .toPromise()
      .then(() => {
        this.lessons = null;
        return this.getAllLessons();
      });
    } else return Promise.reject(null);
  }

  sortLessons() {
    this.lessons.sort((a: Lesson, b: Lesson) => <any>b.lastModified - <any>a.lastModified);
  }

  getLesson(id: number | string) : Promise<Lesson> {
    let lesson: Lesson;
    return this.getAllLessons()
    .then(() => {
      lesson = this.lessons.filter(lesson => lesson.id == id)[0];
      return this.getQuestionsForLesson(id);
    })
    .then((data: any) => {
      let questionJson: any = data.json();
      lesson.updateLessonQuestionsWithJson(questionJson);
      return lesson;
    });
  }

  getQuestionsForLesson(id: number | string) : Promise<any> {
    return this._http.get(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/lessons/' + id + '/questions', { headers: this._session.headers()})
          .toPromise();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/lessons.service.ts